import { createContext } from "react";

const BrokerComponentContext = createContext({});

export default BrokerComponentContext;
